import {useGameStore} from '../GameStoreContext.ts'

export const useHasOnlyOneHumanPlayer = () => {
    const userStates = useGameStore((state) => state.gameUserStates.userStates)
    return userStates.filter((userState) => !userState.isBot).length === 1
}
